export const publicKey = '7e9af7a8a31946fec14f66f82fbbaee8';
export const privateKey = '1f45c606cd63da6aaa674b968d1c964649e1a609';
export const storageKey = '@MarvizStorage:';

export const prodConfig = {
    apiKey: "AIzaSyDw2i2cuKexrIAKNG85wEU_Y-a5HTUkEKI",
    authDomain: "marviz.firebaseapp.com",
    databaseURL: "https://marviz.firebaseio.com",
    projectId: "marviz",
    storageBucket: "marviz.appspot.com",
    messagingSenderId: "355894380417"
};

export const devConfig = {
    apiKey: "AIzaSyDw2i2cuKexrIAKNG85wEU_Y-a5HTUkEKI",
    authDomain: "marviz.firebaseapp.com",
    databaseURL: "https://marviz.firebaseio.com",
    projectId: "marviz",
    storageBucket: "marviz.appspot.com",
    messagingSenderId: "355894380417"
};
